/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit RetakeAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import FileUploadInput from 'DesignSystem/FileUploadInput/react'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function RetakeAction({
  children,
  viewPath = "/DesignSystem/CaptureImageSeries/Content/Active/Content/Images/ImageSlot/Edit/Content/RetakeAction",
  isSubmitting
  
}) {
let imageIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'image',
})
let onChange = fromHelpers.useOnChange({
  children,
  viewPath,
  isSubmitting
  
})
let imageIsSubmittingData1 = fromData.useDataIsSubmitting({ viewPath,
context: 'image',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<FileUploadInput
  viewPath={`${viewPath}/FileUploadInput`}
 accept="image/jpeg"
 capture="environment"
 onChange={onChange}
 data="image"
 disabled={imageIsSubmittingData}
>
{childProps => (
<TysiaButton
{...childProps}
  viewPath={`${viewPath}/TysiaButton`}
 alignSelf="auto"
 marginLeft={dtSpaceXs}
 type="secondary"
 size="medium"
 data="image"
 disabled={imageIsSubmittingData1}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Retake"
/>
)}
</TysiaButton>
)}
</FileUploadInput>
{children}
</React.Fragment>)
}